const tasks = [
    {
        id: '#NZ1220',
        title: 'Admin layout design',
        text: 'Sed ut perspiciatis unde',
        date: '17 Apr, 2020',
        user: ['assets/images/users/avatar-3.jpg', 'assets/images/users/avatar-2.jpg'],
        status: 'todo'
    },
    {
        id: '#NZ1219',
        title: 'Chat app page',
        text: 'Neque porro quisquam est',
        date: '15 Apr, 2019',
        user: ['assets/images/users/avatar-6.jpg'],
        status: 'todo'
    },
    {
        id: '#NZ1218',
        title: 'Ecommerce App pages',
        date: '12 Apr, 2019',
        text: 'Itaque earum rerum hic',
        user: ['assets/images/users/avatar-5.jpg'],
        status: 'todo'
    },
    {
        id: '#NZ1217',
        title: 'Dashboard UI',
        text: 'In enim justo, rhoncus ut',
        date: '05 Apr, 2020',
        user: ['assets/images/users/avatar-6.jpg'],
        status: 'inprogress'
    },
    {
        id: '#NZ1216',
        title: 'Authentication pages',
        text: 'Imperdiet Etiam ultricies',
        date: '02 Apr, 2020',
        user: ['assets/images/users/avatar-8.jpg', 'assets/images/users/avatar-1.jpg'],
        status: 'inprogress'
    },
    {
        id: '#NZ1215',
        title: 'UI Elements pages',
        text: 'Cras ultricies mi eu turpis',
        date: '28 Mar, 2020',
        user: ['assets/images/users/avatar-2.jpg'],
        status: 'inprogress'
    },
    {
        id: '#NZ1214',
        title: 'Brand logo design',
        text: 'Aenean leo ligula, porttitor eu',
        date: '24 Mar, 2020',
        user: ['assets/images/users/avatar-4.jpg'],
        status: 'completed'
    },
    {
        id: '#NZ1213',
        title: 'Email pages',
        text: 'It will be as simple as Occidental',
        date: '20 Mar, 2020',
        user: ['assets/images/users/avatar-6.jpg', 'assets/images/users/avatar-7.jpg'],
        status: 'completed'
    },
    {
        id: '#NZ1212',
        title: 'Forms pages',
        text: 'Donec quam felis, ultricies nec',
        date: '14 Mar, 2019',
        user: ['assets/images/users/avatar-5.jpg'],
        status: 'completed'
    },
];

export { tasks };

